import { SVGOverlay as SVGOverlay_ } from 'react-leaflet';
export var SVGOverlay = SVGOverlay_;
export default SVGOverlay;
